import { Alert } from "antd";

function ClosableContainer({ onClose, children, style = {}, className = "" }) {
    return <Alert style={style} className={["closable-container", className].join(" ")} type="info" closable={{ onClose }} description={children}></Alert>;
}

export default ClosableContainer;
